// src/components/financials/BiggestMovers.jsx
// SCREENER-FINANCIALS — updated this pass: backend now caps display
// magnitude at ±500% (epsGrowthQoQCapped/salesGrowthQoQCapped flags) rather
// than showing raw division-by-near-zero-prior-EPS artifacts like +1000%.
// Real, uncapped figures remain visible in the ticker tab's own period
// detail — this hub view is a "biggest movers" summary, not the source of
// truth for exact magnitude.

import React from 'react';

function MoverRow({ item, onNavigate }) {
  const epsAbs = Math.abs(item.epsGrowthQoQ || 0);
  const salesAbs = Math.abs(item.salesGrowthQoQ || 0);
  const useEps = epsAbs >= salesAbs;
  const primary = useEps ? item.epsGrowthQoQ : item.salesGrowthQoQ;
  const primaryCapped = useEps ? item.epsGrowthQoQCapped : item.salesGrowthQoQCapped;
  const primaryLabel = useEps ? 'EPS QoQ' : 'Sales QoQ';
  const positive = (primary || 0) >= 0;
  const displayPct = (Math.abs(primary) * 100).toFixed(1);

  return (
    <button onClick={() => onNavigate && onNavigate('stock', { ticker: item.ticker })}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
        padding: '0.75rem 1rem', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: '10px', marginBottom: '0.5rem', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left' }}>
      <div>
        <div style={{ fontSize: '0.9rem', fontWeight: 800, color: '#f8fafc' }}>{item.ticker}</div>
        <div style={{ fontSize: '0.72rem', color: '#64748b' }}>{item.fiscalPeriod} {item.fiscalYear} · Filed {item.filedDate}</div>
      </div>
      <div style={{ textAlign: 'right' }}>
        <div style={{ fontSize: '0.95rem', fontWeight: 800, color: positive ? '#00ff88' : '#ff4444' }}
          title={primaryCapped ? 'Capped for display — small prior-period base inflates the raw percentage' : undefined}>
          {primaryCapped ? (positive ? '>' : '<-') : (positive ? '+' : '-')}{displayPct}%
        </div>
        <div style={{ fontSize: '0.68rem', color: '#475569' }}>
          {primaryLabel}{primaryCapped ? ' (capped)' : ''}
        </div>
      </div>
    </button>
  );
}

export default function BiggestMovers({ items, onNavigate }) {
  return (
    <div>
      <div style={{ fontSize: '0.85rem', fontWeight: 800, color: '#f8fafc', marginBottom: '0.75rem' }}>
        Recently Reported — Biggest Movers
      </div>
      {items.length === 0 ? (
        <div style={{ padding: '1.25rem', textAlign: 'center', color: '#475569', fontSize: '0.82rem' }}>
          No significant moves in the last 14 days of filings.
        </div>
      ) : (
        items.map(item => (
          <MoverRow key={item.ticker + item.fiscalYear + item.fiscalPeriod} item={item} onNavigate={onNavigate} />
        ))
      )}
    </div>
  );
}
